module.exports = __webpack_public_path__ + "img/OffShelf.37a5877a.png";